import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const searchSlice = createSlice({
    name: "search",
    initialState: { value: "" },
    reducers: {
        onChange: (state, action) => {
            state.value = action.payload;
        }
        
    },
})
export const { onChange } = searchSlice.actions;
export default searchSlice.reducer;